import SkillsSearch from "./skillsSearch";

export default SkillsSearch;
